import React from 'react'
import { Paper, TableBody, TableCell, TableRow, Tooltip } from '@material-ui/core'
import NumericLabel from 'react-pretty-numbers';
import { EmptyCollection, TableListComp } from '../../../../shared_elements'
import moment from 'moment'
import { displayDateFormat } from '../../../../constants'
import { showCurrencyFormat } from '../../../../utils'
import { Info } from '@material-ui/icons';
const rentalHd = [
  { label: "Transaction Type" },
  { label: "Invoice Number" },
  { label: "Invoice Date" },
  { label: "Sent Date" },
  { label: "Invoice Amount" },
  { label: "Total" }
]

const SecurityList = ({ item }) => {
  return (
    <TableRow className='cshflw-crd-bdy-row'>
      <TableCell>
        <div style={{ fontFamily: 'Conv_IBMPlexSans-medium' }}>{item?.transaction_type_name || '---'}</div>
        {item?.is_partial? <div>(Partial Payment)</div>:null}
      </TableCell>
      <TableCell> {item?.invoice_id?
          <p onClick={()=>{window.open(`invoice/view/${item?.invoice_id}`,'_blank')}}>{item?.invoice_number || '--'}</p>:
          '--'}</TableCell>
      <TableCell>{item?.invoice_date ? moment(item?.invoice_date).format(displayDateFormat) : '--'}</TableCell>
      <TableCell>{item?.sent_date ? moment(item?.sent_date).format(displayDateFormat) : '--'}</TableCell>
       <TableCell style={{color:item?.is_negative? 'red' : 'black'}}>
        <NumericLabel params={showCurrencyFormat()}>
          {item.invoice_amount || 0}
        </NumericLabel> &nbsp;
        {item?.excess_amount ?
          <Tooltip title={`Excess Amount: US$${item?.excess_amount}`} arrow>
            <Info style={{ fontSize: '15px' }} />
          </Tooltip> : null}
      </TableCell>
      <TableCell>
        <NumericLabel params={showCurrencyFormat()}>
          {item.total ||0}
        </NumericLabel>
      </TableCell>
    </TableRow>
  )
}
export default function SecurityCard({ data }) {
  return (
    <div className="cshflw-crd">
      <div className="cshflw-crd-hdr">
        <h5>Security Deposit</h5>
        <div>Total Balance: &nbsp;
        <b><NumericLabel params={showCurrencyFormat()}>
          {data.total ||0}
        </NumericLabel></b>
        </div>
      </div>
      <div className="cshflw-crd-bdy">
        <TableListComp
          maxheight={'max-content'}
          heads={rentalHd}
          data={data?.items.map((item, index) =>
            <SecurityList
              key={index}
              item={item}
            />
          )}
        />
      </div>
    </div>
  )
}
